import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { HERO_IMG, SITE_NAME, SITE_URL } from "../lib/branding";
import { fetchSettings, mediaUrl } from "../lib/api";

const DEFAULT_IMAGE = HERO_IMG;

const DEFAULT_TITLE =
    "ASC Interior — Hospitality Interior Design, Bangkok since 2003";
const DEFAULT_DESCRIPTION =
    "ASC Interior Co., Ltd. — a Bangkok studio founded in 2003. Building spaces, building trust: hospitality interiors for hotels, resorts, restaurants and residences across Asia and the Middle East.";

// Cache settings across the app — fetched once per session.
let _cachedOgImage = null;
let _cachedPromise = null;
const getOgImage = () => {
    if (_cachedOgImage) return Promise.resolve(_cachedOgImage);
    if (_cachedPromise) return _cachedPromise;
    _cachedPromise = fetchSettings()
        .then((s) => {
            const u = s?.og_image || s?.hero_image;
            _cachedOgImage = u ? mediaUrl(u) : null;
            return _cachedOgImage;
        })
        .catch(() => null);
    return _cachedPromise;
};

export default function Seo({
    title,
    description,
    image,
    path = "/",
    type = "website",
    noindex = false,
}) {
    const [cmsImage, setCmsImage] = useState(null);
    useEffect(() => {
        let cancelled = false;
        getOgImage().then((u) => { if (!cancelled && u) setCmsImage(u); });
        return () => { cancelled = true; };
    }, []);

    const fullTitle = title
        ? `${title} · ${SITE_NAME}`
        : DEFAULT_TITLE;
    const desc = description || DEFAULT_DESCRIPTION;
    const img = image || cmsImage || DEFAULT_IMAGE;
    const url = `${SITE_URL}${path}`;

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={desc} />
            <link rel="canonical" href={url} />
            {noindex && <meta name="robots" content="noindex, nofollow" />}

            {/* Open Graph */}
            <meta property="og:site_name" content={SITE_NAME} />
            <meta property="og:type" content={type} />
            <meta property="og:url" content={url} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={desc} />
            <meta property="og:image" content={img} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={desc} />
            <meta name="twitter:image" content={img} />
        </Helmet>
    );
}
